import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLBoolean,
  GraphQLInputObjectType
} from 'graphql'
import { dateTimeType } from './date-time-type'

export interface SourceNamesQueryArgs {
  readonly organizationID: string
}

export const sourceNamesQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export interface SourceNameQueryArgs {
  readonly organizationID: string
  readonly id: string
}

export const sourceNameQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  id: {
    description: 'The unique ID for the source name being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export interface SourceName {
  readonly id: string
  readonly name: string
  readonly start: Date
  readonly expiration?: Date
  readonly expired: boolean
  readonly cidrBlocks: string[]
  readonly modified: Date
}

export const sourceNameType = new GraphQLObjectType({
  name: 'SourceName',
  fields: () => ({
    id: {
      description: 'The unique ID for a source name',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name for the source',
      type: new GraphQLNonNull(GraphQLString)
    },
    start: {
      description: 'The start date for the source name',
      type: new GraphQLNonNull(dateTimeType)
    },
    expiration: {
      description: 'The expiration date for the source name',
      type: dateTimeType
    },
    expired: {
      description: 'Expired flag',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    cidrBlocks: {
      description: 'The blocks of IPs for the source name',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(GraphQLString))
      )
    },
    modified: {
      description: 'The last modified date for the source name',
      type: new GraphQLNonNull(dateTimeType)
    }
  })
})

export const sourceNameInputType = new GraphQLInputObjectType({
  name: 'SourceNameInput',
  fields: () => ({
    name: {
      description: 'The name for the source',
      type: new GraphQLNonNull(GraphQLString)
    },
    start: {
      description: 'The start date for the source name',
      type: dateTimeType
    },
    expiration: {
      description: 'The expiration date for the source name',
      type: dateTimeType
    },
    cidrBlocks: {
      description: 'The blocks of IPs for the source name',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(GraphQLString))
      )
    }
  })
})
